<template>
    <div class="airport-search-input">
        <input type="hidden" ref="hiddenInput" :name="name" :value="value" />
        <md-field
            class="with-left-icon"
            v-bind:class="{ 'md-invalid': !!inputError }"
        >
            <label v-if="!noLabel">{{ label }}</label>
            <!-- Do not remove. This label is required to disable Chrome's autofill feature -->
            <label style="display: none">disable autofill</label>
            <custom-icon v-if="!noIcon" class="md-prefix" :name="useIcon" />
            <md-input
                type="text"
                v-model="selectedcityName"
                ref="searchInput"
                :placeholder="label + (required ? ' *' : '')"
                v-on:blur="onBlur($event)"
                :disabled="disabled"
                dusk="city-search-input"
                :autofocus="autofocus"
                id="autocomplete-search-input"
                :required="required"
            />
            <md-progress-spinner
                v-show="searching"
                md-mode="indeterminate"
                :md-diameter="20"
                :md-stroke="3"
            />
            <span class="md-error">{{ inputError ? inputError[0] : "" }}</span>
        </md-field>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        label: String,
        value: Number,
        cityName: String,
        icon: String,
        noLabel: Boolean,
        inputError: Array,
        disabled: String,
        autofocus: String,
        noIcon: {
            type: Boolean,
            default: false,
        },
        required: Boolean,
    },
    data: () => {
        return {
            searchTimeout: null,
            source: null,
            typeahead: null,
            storedcityName: null,
            overridecityName: null,
            searching: false,
            limit: 10,
            touched: false,
        };
    },
    computed: {
        selectedcityName: {
            get() {
                if (this.cityName && this.overridecityName === null) {
                    this.overridecityName = this.cityName;
                }
                return this.overridecityName !== null
                    ? this.overridecityName
                    : this.cityName;
            },
            set(value) {
                this.overridecityName = value;
            },
        },
        useIcon() {
            return this.icon ? this.icon : "flight_takeoff";
        },
    },
    mounted() {
        this.storedcityName = this.cityName;
        this.initSource();
        this.initTypeahead();
    },
    methods: {
        initSource() {
            this.source = (query, syncResults, asyncResults) => {
                if (this.touched) {
                    if (this.searchTimeout) {
                        clearTimeout(this.searchTimeout);
                    }
                    this.searching = true;
                    this.searchTimeout = setTimeout(() => {
                        let finalResults = [];
                        axios.get(
                            '/api/cities',
                            {
                                params: {
                                    term: query,
                                    per_page: this.limit - finalResults.length,
                                    disable_pagination: 1,
                                    with_country: 1,
                                },
                            }
                        ).then((response) => {
                            finalResults = finalResults.concat(
                                response.data.map((c) => {
                                    c['type'] = 'city';
                                    c['icon'] = 'location_city';
                                    c['label'] = Vue.i18n.translate(
                                        'registration.search-city',
                                        {
                                            city: c['name_list'].split(
                                                ','
                                            )[0],
                                            department_country:
                                                (c['adminLevel2']
                                                    ? c['adminLevel2'][
                                                        'name'
                                                    ] + ', '
                                                    : c['adminLevel1']
                                                        ? c['adminLevel1'][
                                                            'name'
                                                        ] + ', '
                                                        : c['postalCode']
                                                            ? c['postalCode'] + ', '
                                                            : '') +
                                                c['country']['nom'][this.$i18n.locale()],
                                        }
                                    );
                                    return c;
                                })
                            );
                            asyncResults(finalResults);
                            this.searching = false;
                        });
                    }, 300);
                }
            };
        },
        initTypeahead() {
            this.typeahead = $(this.$refs.searchInput.$el).typeahead(null, {
                display: 'label',
                source: this.source,
                templates: {
                    suggestion: Handlebars.compile(
                        '<div><i class="material-icons">{{icon}}</i> {{label}}</div>'
                    ),
                },
                hint: false,
                minLength: 2,
                limit: 2 * this.limit,
            });
            this.typeahead.bind("typeahead:select", (event, suggestion) => {
                this.$emit("input", suggestion["id"]);
                this.selectedcityName = suggestion["label"];
                this.storedcityName = suggestion["label"];
            });
        },
        onBlur(event) {
            if (!this.value || this.overridecityName === "") {
                this.$emit("input", null);
                this.storedcityName = "";
                this.overridecityName = "";
            } else if (this.overridecityName !== this.storedcityName) {
                this.overridecityName = this.storedcityName;
                this.typeahead.typeahead("val", "");
            }
            this.touched = false;
        },
        clearAndFocus() {
            this.selectedcityName = "";
            this.$refs.searchInput.$el.focus();
        },
    },
    watch: {
        selectedcityName(value) {
            this.touched = true;
        },
    },
};
</script>
<style lang="scss" >
@import "~styles/_variables";
#autocomplete-search-input {
    color: $primary-color-dark;
}
#autocomplete-search-input::placeholder {
    color: $primary-color-dark;
    font-size: 16px;
    @media (max-width: $mobile-top-breakpoint) {
        font-size: 12px;
    }
    line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/widgets/CityInputComponent.vue